<!-- <div class="sub-entities-scroll-container" id="entity-container" infiniteScroll [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="1000" [scrollWindow]="false" (scrolled)="onScrollDown()" *ngIf="pageFrom == 'jobsApplied'">

  <div class="header-row">
    <div class="stage-count-section">
      <div
        class="stage-count-item all"
        [class.active]="selectedStage === 'ALL'"
        (click)="selectStage('ALL')">
         <div class="stage-label">All</div>
         <div>{{stageCounts?.all || 0}}</div>
      </div>

      <div
        class="stage-count-item applied"
        [class.active]="selectedStage === 'JOB-APPLIED'"
        (click)="selectStage('JOB-APPLIED')">
        <div class="stage-label">Applied</div>
        <div>{{stageCounts?.applied || 0}}</div>
      </div>

      <div
        class="stage-count-item in-process"
        [class.active]="selectedStage === 'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW'"
        (click)="selectStage('CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW')">
         <div class="stage-label">In Process</div>
        <div>{{stageCounts?.inProcess || 0}}</div>
      </div>

      <div
        class="stage-count-item selections"
        [class.active]="selectedStage === 'CANDIDATE-SELECTED'"
        (click)="selectStage('CANDIDATE-SELECTED')">
         <div class="stage-label">Selected</div>
        <div>{{stageCounts?.selected || 0}}</div>
      </div>

      <div
        class="stage-count-item offers"
        [class.active]="selectedStage === 'OFFERED'"
        (click)="selectStage('OFFERED')">
          <div class="stage-label">Offers</div>
        <div>{{stageCounts?.offered || 0}}</div>
      </div>

      <div
        class="stage-count-item onboards"
        [class.active]="selectedStage === 'ONBOARDED'"
        (click)="selectStage('ONBOARDED')">
          <div class="stage-label">Onboards</div>
        <div>{{stageCounts?.onboarded || 0}}</div>
      </div>
    </div>

    <div class="search-filter-section">
      <div class="search-container-650-1">
        <ng-icon name="tablerSearch" class="search-icon-650-1"></ng-icon>
        <input type="text" #searchInput
          id="jobs_applied_search"
          class="search-box-650"
          placeholder="Search Jobs,Title,ID,Tags"
          [(ngModel)]="searchText"
          (keyup)="filterJobs()">
      </div>

      <button id="jobs_applied_filter_button" class="icon-btn filter-btn" (click)="openFilterSlider()" title="Filter">
        <ng-icon name="tablerFilter"></ng-icon>
        <span *ngIf="jobAppliedStatusList?.length > 0" class="filter-count">{{jobAppliedStatusList.length}}</span>
      </button>
    </div>
  </div>

  <div>
    <div class="col-12" *ngIf="loadAPIcall && passValues?.length==0">
      <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>

    <ng-container *ngIf="passValues.length > 0; else noResult">
      <div *ngFor="let item of passValues; let i = index;">
        <app-job-card [viewSize]="'medium'" [indexInput]="i" [showCheckBox]="'false'" (jobemit)="getjobId($event)"  [From]="'JOBS_FROM_PLATFORM'"
          [filterApplicantData]="filterApplicantData" [JobData]="item" [JobDataUser]="item.user" [candidateData]="candidateDetails" [showTimeline]="true"  (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"></app-job-card>
        <app-common-skeleton   *ngIf="loadAPIcall && passValues?.length>0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>
      <div *ngIf="stopscrollFlag  && passValues.length > 0" class="caught_up">
        <div class="col-md-12">
          <ng-icon name="tablerCircleCheck"></ng-icon>
        </div>
        <div class="col-md-12">
          <p class="biase">You've reached the bottom of the page</p>
        </div>
      </div>
    </ng-container>
  
    <ng-template #noResult>
      <div class="wert">
        <div class="col-md-12 mg-bt-9">
          <ng-icon name="tablerBriefcase" *ngIf="responseReceived"></ng-icon>
          <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon>
        </div>
        <div class="col-md-12 fig">{{jobsAppliedFoundStatus}} </div>
      </div>
    </ng-template>
  </div>
</div> -->


<!-- ═══════════════════════════════════════════
     V3 DESIGN — Jobs Applied / Suggested Jobs
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">

  <!-- Marketplace Jobs — AI Smart Search banner + summary stat cards.
       Mirrors the Marketplace Candidates design (wireframe
       gigsumo_job_center_v2(16).html #tab-marketplace). Stat values are
       placeholders (0) for now and will be wired to the API's real
       counts / scores later. -->
  <ng-container *ngIf="pageFrom === 'suggestedJobs'">
    <div class="jc-v3-ai-banner">
      <div class="jc-v3-ai-banner-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/><path d="M11 8v6M8 11h6"/></svg>
      </div>
      <div class="jc-v3-ai-banner-body">
        <div class="jc-v3-ai-banner-title">
          Results powered by Smart Search
          <span class="jc-v3-ai-chip">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            AI
          </span>
        </div>
        <div class="jc-v3-ai-banner-sub">Marketplace jobs are surfaced based on your profile fit, location, and network proximity.</div>
      </div>
    </div>

    <div class="jc-v3-stat-grid jc-v3-stat-grid-3">
      <div class="jc-v3-stat-card acc-purple">
        <div class="jc-v3-s-label">Marketplace</div>
        <div class="jc-v3-s-value">{{ marketplaceTotalCount || 0 }}</div>
        <div class="jc-v3-s-sub">Available jobs</div>
      </div>
      <div class="jc-v3-stat-card acc-green">
        <div class="jc-v3-s-label">Top Match</div>
        <div class="jc-v3-s-value">{{ topMatchScore || 0 }}%</div>
        <div class="jc-v3-s-sub">Highest match score</div>
      </div>
      <div class="jc-v3-stat-card acc-amber">
        <div class="jc-v3-s-label">Via Recruiters</div>
        <div class="jc-v3-s-value">{{ viaRecruitersCount || 0 }}</div>
        <div class="jc-v3-s-sub">Freelance network</div>
      </div>
    </div>
  </ng-container>

  <!-- Stat Cards — only on "Applied" tab, not Suggested Jobs -->
  <div class="jc-v3-stat-grid jc-v3-stat-grid-4" *ngIf="pageFrom != 'suggestedJobs'">
    <div class="jc-v3-stat-card acc-purple">
      <div class="jc-v3-s-label">Total Applied</div>
      <div class="jc-v3-s-value">{{ stageCounts?.all || 0 }}</div>
      <div class="jc-v3-s-sub">All time</div>
    </div>
    <div class="jc-v3-stat-card acc-green">
      <div class="jc-v3-s-label">In Process</div>
      <div class="jc-v3-s-value">{{ stageCounts?.inProcess || 0 }}</div>
      <div class="jc-v3-s-sub">Active pipeline</div>
    </div>
    <div class="jc-v3-stat-card acc-amber">
      <div class="jc-v3-s-label">Selected</div>
      <div class="jc-v3-s-value">{{ stageCounts?.selected || 0 }}</div>
      <div class="jc-v3-s-sub">Shortlisted</div>
    </div>
    <div class="jc-v3-stat-card acc-blue">
      <div class="jc-v3-s-label">Onboarded</div>
      <div class="jc-v3-s-value">{{ stageCounts?.onboarded || 0 }}</div>
      <div class="jc-v3-s-sub">Completed</div>
    </div>
  </div>

  <!-- Pipeline Filter Tabs + Search + Filter — hidden on Marketplace Jobs
       (suggestedJobs): the tabs/filter are already suppressed there and the
       search isn't needed, so the whole bar is dropped to avoid an empty row. -->
  <div class="jc-v3-pip-bar" *ngIf="pageFrom != 'suggestedJobs'">
    <ng-container *ngIf="pageFrom != 'suggestedJobs'">
      <button class="jc-v3-pip-tab" [class.active]="!selectedStage || selectedStage === 'ALL'" (click)="selectStage('ALL')">
        All <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.all > 0">{{ stageCounts.all }}</span>
      </button>
      <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'JOB-APPLIED'" (click)="selectStage('JOB-APPLIED')">
        Applied <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.applied > 0">{{ stageCounts.applied }}</span>
      </button>
      <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW'" (click)="selectStage('CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW')">
        In Process <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.inProcess > 0">{{ stageCounts.inProcess }}</span>
      </button>
      <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'CANDIDATE-SELECTED'" (click)="selectStage('CANDIDATE-SELECTED')">
        Selected <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.selected > 0">{{ stageCounts.selected }}</span>
      </button>
      <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'OFFERED,OFFER-ACCEPTED'" (click)="selectStage('OFFERED,OFFER-ACCEPTED')">
        Offers <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.offered > 0">{{ stageCounts.offered }}</span>
      </button>
      <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'PRE-ONBOARDED,ONBOARDED'" (click)="selectStage('PRE-ONBOARDED,ONBOARDED')">
        Onboards <span class="jc-v3-pip-cnt" *ngIf="stageCounts?.onboarded > 0">{{ stageCounts.onboarded }}</span>
      </button>
    </ng-container>
    <div class="jc-v3-cand-srch">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
      <input type="text" placeholder="Search Jobs, Title, ID, Tags" [(ngModel)]="searchText" (keyup)="filterJobs()">
    </div>
    <div class="jc-v3-icon-btn" (click)="openFilterSlider()" *ngIf="pageFrom != 'suggestedJobs'" title="Filter">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
      <span *ngIf="jobAppliedStatusList?.length > 0" class="filter-count">{{jobAppliedStatusList.length}}</span>
    </div>
  </div>

  <!-- Job list — scroll delegated to the outer `.jc-v3-entity-details-body`
       (job-center-v3.scss:2323). This mirrors the applicants tab fix:
       eliminating the inline `height + overflow-y: auto` removes the second
       scrollbar that was nesting inside the already-scrollable body.
       infiniteScroll listens on that outer container via
       [infiniteScrollContainer] + [fromRoot] so pagination still fires.
       Same wiring as candidate-viewed-by (Views): the directive is the primary
       trigger (distance 2 = fetch two container-heights before the bottom);
       the #scrollSentinel IntersectionObserver below stays as the backup.
       Both go through the same guarded onScrollDown(). -->
  <div #jobsListRoot infiniteScroll
       [infiniteScrollDistance]="2"
       [infiniteScrollThrottle]="200"
       [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
       [fromRoot]="true"
       [alwaysCallback]="true"
       (scrolled)="onScrollDown()">
    <!-- Suggested Jobs (Marketplace) has its own branded "AI is analyzing jobs"
         loading card below, so suppress the generic skeleton there — otherwise
         both showed at once during the AI-polling window. -->
    <div class="col-12" *ngIf="loadAPIcall && passValues?.length === 0 && pageFrom !== 'suggestedJobs'">
      <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>
    <ng-container *ngIf="passValues?.length > 0; else noResultV3">
      <div *ngFor="let item of passValues; let i = index;">
        <app-job-card
          [pageFrom]="pageFrom"
          [viewSize]="'jc-v3-row'"
          [indexInput]="i"
          [showCheckBox]="'false'"
          (jobemit)="getjobId($event)"
          [From]="'JOBS_FROM_PLATFORM'"
          [filterApplicantData]="filterApplicantData"
          [JobData]="item"
          [JobDataUser]="item.user"
          [candidateData]="candidateDetails"
          [currentCandidateId]="candidateDetails?.candidateId"
          [showTimeline]="pageFrom != 'suggestedJobs' ? true : false"
          (statusUpdated)="handleStatusUpdate()"
          (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)">
        </app-job-card>
      </div>
      <app-common-skeleton *ngIf="loadAPIcall && passValues?.length > 0" [countforView]="2"
        [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      <div *ngIf="stopscrollFlag && passValues?.length > 0" class="jc-v3-list-done">
        <ng-icon name="tablerCircleCheck"></ng-icon>
        <p>You've reached the bottom of the page</p>
      </div>
    </ng-container>
    <ng-template #noResultV3>
      <!-- Suggested Jobs — AI is still polling (mirrors marketplace
           candidates behaviour). Shown for the duration of
           `suggestionsWithRetry`'s ~75s retry window. -->
      <div *ngIf="pageFrom === 'suggestedJobs' && !responseReceived" class="jc-v3-empty-state">
        <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
          <circle cx="100" cy="90" r="40" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
          <path d="M100 70 v25 l15 10" stroke="#7C3AED" stroke-width="2.5" stroke-linecap="round" fill="none"/>
          <circle cx="148" cy="58" r="14" fill="#C4B5FD"/>
          <polygon points="148,51 151,57 157,57 152,61 154,67 148,63 142,67 144,61 139,57 145,57" fill="#ffffff"/>
          <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
          <circle cx="155" cy="128" r="2" fill="#C4B5FD"/>
        </svg>
        <h3>AI is analyzing jobs</h3>
        <p>{{ noResultMessage }}</p>
      </div>

      <!-- Suggested Jobs — retries exhausted, no matches. -->
      <div *ngIf="pageFrom === 'suggestedJobs' && responseReceived" class="jc-v3-empty-state">
        <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
          <rect x="58" y="50" width="84" height="72" rx="8" fill="#ffffff" stroke="#7C3AED" stroke-width="1.8"/>
          <rect x="68" y="64" width="32" height="4" rx="2" fill="#DDD6FE"/>
          <rect x="68" y="73" width="44" height="4" rx="2" fill="#EDE9FE"/>
          <rect x="68" y="82" width="36" height="4" rx="2" fill="#EDE9FE"/>
          <circle cx="148" cy="130" r="16" fill="#7C3AED" opacity="0.10"/>
          <circle cx="148" cy="130" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
          <line x1="144" y1="130" x2="152" y2="130" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
          <line x1="148" y1="126" x2="148" y2="134" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
          <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
          <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
        </svg>
        <h3>No Marketplace Jobs Yet</h3>
        <p *ngIf="!isDraftCandidate">AI-matched jobs for this candidate will appear here.</p>
        <p *ngIf="isDraftCandidate">AI cannot match jobs for drafted candidates.</p>
      </div>

      <!-- Jobs Applied — unchanged from existing behaviour: skeleton
           covers the fetch (loadAPIcall is set in getAppliedFilter
           path), so the empty card surfaces only after the response
           resolves with no rows. -->
      <div *ngIf="pageFrom !== 'suggestedJobs' && (!loadAPIcall || responseReceived)" class="jc-v3-empty-state">
        <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
          <rect x="58" y="50" width="84" height="72" rx="8" fill="#ffffff" stroke="#7C3AED" stroke-width="1.8"/>
          <rect x="68" y="64" width="32" height="4" rx="2" fill="#DDD6FE"/>
          <rect x="68" y="73" width="44" height="4" rx="2" fill="#EDE9FE"/>
          <rect x="68" y="82" width="36" height="4" rx="2" fill="#EDE9FE"/>
          <circle cx="148" cy="130" r="16" fill="#7C3AED" opacity="0.10"/>
          <circle cx="148" cy="130" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
          <line x1="144" y1="130" x2="152" y2="130" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
          <line x1="148" y1="126" x2="148" y2="134" stroke="#7C3AED" stroke-width="2" stroke-linecap="round"/>
          <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
          <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
        </svg>
        <h3>No Jobs Applied Yet</h3>
        <p>Jobs this candidate has applied to will appear here.</p>
      </div>
    </ng-template>
    <div #scrollSentinel style="height:1px;"></div>
  </div>
</ng-container>

<!-- ═══════════════════════════════════════════
     V2 DESIGN (existing)
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" id="entity-container">

  <!-- Header Row with Stage Counts and Search/Filter -->
   <!-- [style.justify-content]="pageFrom === 'suggestedJobs' ? 'end' : ''" -->
  <div class="header-row" *ngIf="pageFrom != 'suggestedJobs'" >
    <div class="stage-count-section"  >
      <!-- All Tab (Default) -->
      <div
        class="stage-count-item all"
        [class.active]="selectedStage === 'ALL'"
        (click)="selectStage('ALL')">
         <div class="stage-label">All</div>
         <div>{{stageCounts?.all || 0}}</div>
      </div>

      <div
        class="stage-count-item applied"
        [class.active]="selectedStage === 'JOB-APPLIED'"
        (click)="selectStage('JOB-APPLIED')">
        <div class="stage-label">Applied</div>
        <div>{{stageCounts?.applied || 0}}</div>
      </div>

      <div
        class="stage-count-item in-process"
        [class.active]="selectedStage === 'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW'"
        (click)="selectStage('CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW')">
         <div class="stage-label">In Process</div>
        <div>{{stageCounts?.inProcess || 0}}</div>
      </div>

      <div
        class="stage-count-item selections"
        [class.active]="selectedStage === 'CANDIDATE-SELECTED'"
        (click)="selectStage('CANDIDATE-SELECTED')">
         <div class="stage-label">Selected</div>
        <div>{{stageCounts?.selected || 0}}</div>
      </div>

      <div
        class="stage-count-item offers"
        [class.active]="selectedStage === 'OFFERED,OFFER-ACCEPTED'"
        (click)="selectStage('OFFERED,OFFER-ACCEPTED')">
          <div class="stage-label">Offers</div>
        <div>{{stageCounts?.offered || 0}}</div>
      </div>

      <div
        class="stage-count-item onboards"
        [class.active]="selectedStage === 'PRE-ONBOARDED,ONBOARDED'"
        (click)="selectStage('PRE-ONBOARDED,ONBOARDED')">
          <div class="stage-label">Onboards</div>
        <div>{{stageCounts?.onboarded || 0}}</div>
      </div>
    </div>

    <!-- Search and Filter Section (Right Side) -->
    <div class="search-filter-section">
      <div class="search-container-650-1">
        <ng-icon name="tablerSearch" class="search-icon-650-1"></ng-icon>
        <input type="text" #searchInput
          id="jobs_applied_search"
          class="search-box-650"
          placeholder="Search Jobs,Title,ID,Tags"
          [(ngModel)]="searchText"
          (keyup)="filterJobs()">
      </div>

      <button id="jobs_applied_filter_button" class="icon-btn filter-btn" (click)="openFilterSlider()" title="Filter"
        *ngIf="pageFrom != 'suggestedJobs'">
        <ng-icon name="tablerFilter"></ng-icon>
        <span *ngIf="jobAppliedStatusList?.length > 0" class="filter-count">{{jobAppliedStatusList.length}}</span>
      </button>
    </div>
  </div>

  <!-- Table Wrapper for Row Design -->
  <div class="jobs-table-wrapper" #scrollContainer
    [style.height]="pageFrom === 'jobsApplied' ? 'calc(100vh - 278px)' : 'calc(100vh - 197px)'"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="200"
    [scrollWindow]="false"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()">
    <div class="jobs-table-container hpanel">

      <!-- Table Header -->
      <div class="jobs-table-header panel-body">
        <div class="header-cell rank-col">Rank</div>
        <div class="header-cell company-col">Posted By</div>
        <div class="header-cell job-location-col">Job Title & Info</div>
        <div class="header-cell skills-col">Skills</div>
        <div class="header-cell match-col">Match %</div>
        <div class="header-cell engagement-col">Engagement</div>
        <div class="header-cell salary-col">Salary</div>
        <div class="header-cell salary-col"  *ngIf="pageFrom != 'suggestedJobs'">Stage</div>
        <div class="header-cell actions-col">Quick Actions</div>
      </div>

      <!-- Loading Skeleton -->
      <div class="col-12" *ngIf="loadAPIcall && passValues?.length==0">
        <app-common-skeleton [countforView]="3" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>

      <!-- Table Body with Job Cards -->
      <ng-container *ngIf="passValues.length > 0; else noResult">
        <div class="jobs-table-body">
          <app-job-card
            *ngFor="let item of passValues; let i = index;"
            [pageFrom]="pageFrom"
            [viewSize]="'row-design'"
            [indexInput]="i"
            [showCheckBox]="'false'"
            (jobemit)="getjobId($event)"
            [From]="'JOBS_FROM_PLATFORM'"
            [filterApplicantData]="filterApplicantData"
            [JobData]="item"
            [JobDataUser]="item.user"
            [candidateData]="candidateDetails"
            [currentCandidateId]="candidateDetails?.candidateId"
            [showTimeline]=" pageFrom != 'suggestedJobs' ? true : false"
            (statusUpdated)="handleStatusUpdate()"
            (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)">
          </app-job-card>

          <app-common-skeleton *ngIf="loadAPIcall && passValues?.length>0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
        </div>

        <!-- Reached Bottom Message -->
        <div *ngIf="stopscrollFlag && passValues.length > 0" class="caught_up">
          <div class="col-md-12">
            <ng-icon name="tablerCircleCheck"></ng-icon>
          </div>
          <div class="col-md-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>
      </ng-container>

      <!-- No Results Template -->
      <ng-template #noResult>
        <div class="wert" *ngIf="!loadAPIcall || responseReceived">
          <div class="col-md-12 mg-bt-9">
            <ng-icon [name]="noResultSvgType"></ng-icon>
          </div>
          <div class="col-md-12 fig">{{noResultMessage}}</div>
        </div>
      </ng-template>

    </div><!-- End of jobs-table-container -->
  </div><!-- End of jobs-table-wrapper -->
</div>
</ng-container>